import { useState, useEffect, useRef } from 'react';

const useDispatcherTimer = (initialSeconds) => {
  const [currentSeconds, setCurrentSeconds] = useState(initialSeconds);
  const timerRef = useRef(null);

  useEffect(() => {
    if (!initialSeconds) return;

    setCurrentSeconds(initialSeconds);

    timerRef.current = setInterval(() => {
      setCurrentSeconds((prevSeconds) => prevSeconds + 1);
    }, 1000);

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [initialSeconds]);

  const hours = String(Math.floor((currentSeconds || 0) / 3600)).padStart(2, '0');
  const minutes = String(Math.floor(((currentSeconds || 0) % 3600) / 60)).padStart(2, '0');
  const seconds = String((currentSeconds || 0) % 60).padStart(2, '0');
  const timerString = `${hours}:${minutes}:${seconds}`;

  const isTimerRunning = currentSeconds !== null;

  return {
    timerString,
    isTimerRunning,
  };
};

export default useDispatcherTimer;
